import React from 'react'
import { useLocation } from 'react-router-dom'
import { Form, Col, Button } from 'react-bootstrap'
import { useFieldArray, useFormContext } from 'react-hook-form'

import ActividadSecundaria from './ActividadSecundaria'

function ActividadesSecundarias({ actividades, actividadesiibb, name, index }) {
  const { control, errors, watch } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control,
    name: `${name}.${index}.secundarias`
  })
  const location = useLocation()

  const watchTipoActividad = watch(`${name}.${index}.tipo_codigo_actividad`)

  return (
    <>
      <h6 className="text-muted text-normal text-uppercase mt-3">
        Actividades Secundarias
      </h6>
      <hr className="mb-4" />
      {fields.map((field, indx) => (
        <React.Fragment key={indx}>
          <Form.Row>
            <ActividadSecundaria
              name={`${name}.${index}.secundarias.${indx}`}
              errorPath={errors?.[name]?.[index]?.secundarias?.[indx]}
              field={field}
              indx={indx}
              tipo_actividad={watchTipoActividad}
              actividades={actividades}
              actividadesiibb={actividadesiibb}
            />

            <Col md={{ span: 2, offset: 1 }}>
              <Form.Group>
                <Form.Label>Eliminar {indx + 1}</Form.Label>
                <Button
                  className="d-block my-0 ml-3"
                  variant="outline-secondary"
                  onClick={() => remove(indx)}
                  disabled={location?.state?.visualizarDatos}
                >
                  <i className="material-icons delete" />
                </Button>
              </Form.Group>
            </Col>

            <hr className="my-2" />
          </Form.Row>
        </React.Fragment>
      ))}

      {fields.length < 10 && (
        <Form.Row>
          <Button
            variant="outline-primary"
            className="btn-block my-4"
            onClick={() => append({})}
            disabled={location?.state?.visualizarDatos}
          >
            Agregar actividad secundaria en sucursal{' '}
            {name === 'externas' && 'externa'} {index + 1}
          </Button>
        </Form.Row>
      )}
    </>
  )
}

export default ActividadesSecundarias
